import { render, staticRenderFns } from "./FileListItem.vue?vue&type=template&id=0b31a202&scoped=true"
import script from "./FileListItem.vue?vue&type=script&lang=js"
export * from "./FileListItem.vue?vue&type=script&lang=js"
import style0 from "./FileListItem.vue?vue&type=style&index=0&id=0b31a202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31a202",
  null
  
)

export default component.exports